module.exports = __webpack_public_path__ + "static/media/section-4.0a8c341d.svg";